import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { supportedBarcodeFormatsFormValidator } from 'src/app/validators/hash.form-validator';

@Component({
  selector: 'app-manual-barcode-input-modal',
  templateUrl: './manual-barcode-input-modal.component.html',
  styleUrls: ['./manual-barcode-input-modal.component.scss'],
})
export class ManualBarcodeInputModalComponent implements OnInit {
  public readonly barcodeControl = new FormControl<string>('', [
    Validators.required,
    supportedBarcodeFormatsFormValidator(),
  ]);

  constructor(public readonly modalService: ModalService) {}

  ngOnInit() {
    return;
  }

  onConfirmClick(): void {
    const value = this.barcodeControl.value!;
    this.modalService.dismiss(value);
  }
}
